import React from 'react';
import { Link } from 'react-router-dom';
import { Col, Row, Layout } from 'antd';

import PdButton from 'components/pd-button';

import { ABOUT_ITEMS } from 'utils';

import './style.scss';
const { Content } = Layout;

export function AboutUs() {
  return (
    <Layout className="pd-cms-about-us main-container">
      <div className="container">
        <div className="content">
          <div className="pageTitle">About Us</div>
          <Content className="pageContent">
            {ABOUT_ITEMS.map(({ title = '', pathname = '', key }) => (
              <div key={key} className="item">
                <Row gutter={20}>
                  <Col span={24}>
                    <Row type="flex" align="middle" gutter={30}>
                      <Col span={11}>
                        <div className="table-title--sort">{title}</div>
                      </Col>
                      <Col span={8} />
                      <Col span={4}>
                        <div className="button-table">
                          <Row className="button">
                            <Link to={pathname}>
                              <PdButton
                                type="primary"
                                className="height-32"
                                full>
                                Edit
                              </PdButton>
                            </Link>
                          </Row>
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </div>
            ))}
          </Content>
        </div>
      </div>
    </Layout>
  );
}

export default { AboutUs };
